"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var mountIsland_1 = require("../mountIsland");
function GetRecordings() {
    var _a = (0, react_1.useState)(''), recordings = _a[0], setRecordings = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/v2/students/minister")
            .then(function (response) {
            setRecordings(response.data.minister.recordings);
            setIsLoading(false);
        })
            .catch(function (error) {
            console.log(error);
            setIsLoading(false);
        });
    }, []);
    if (isLoading)
        return react_1.default.createElement("div", null, "Loading...");
    if (!recordings)
        return react_1.default.createElement("div", null, "No Recordings Available");
    return (react_1.default.createElement("div", { className: "container student-container" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: recordings } })));
}
exports.default = GetRecordings;
var recordingsContainer = document.getElementById('recordings');
if (recordingsContainer) {
    (0, mountIsland_1.mountIsland)(recordingsContainer, react_1.default.createElement(GetRecordings, null));
}
